import React, { useEffect, useState, useRef } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackgroundAnimation from './components/BackgroundAnimation';

const App: React.FC = () => {
  const [isHeroVisible, setIsHeroVisible] = useState(true);
  const heroRef = useRef<HTMLElement>(null);
  const sectionRefs = useRef<HTMLElement[]>([]);

  useEffect(() => {
    const sectionObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const heroObserver = new IntersectionObserver(
      ([entry]) => {
        setIsHeroVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    sectionRefs.current.forEach((section) => {
      if (section) {
        sectionObserver.observe(section);
      }
    });

    const currentHeroRef = heroRef.current;

    if (currentHeroRef) {
      heroObserver.observe(currentHeroRef);
    }

    return () => {
      sectionRefs.current.forEach((section) => {
        if (section) {
          sectionObserver.unobserve(section);
        }
      });
      if (currentHeroRef) {
        heroObserver.unobserve(currentHeroRef);
      }
    };
  }, []);

  useEffect(() => {
    if (isHeroVisible) {
      document.body.classList.add('hero-visible');
    } else {
      document.body.classList.remove('hero-visible');
    }
  }, [isHeroVisible]);

  const addToSectionRefs = (el: HTMLElement | null) => {
    if (el && !sectionRefs.current.includes(el)) {
      sectionRefs.current.push(el);
    }
  };

  return (
    <React.Fragment>
      <Header />
      <main>
        <Hero ref={heroRef} />
        <div className="section-reveal" ref={addToSectionRefs}>
          <About />
        </div>
        <div className="section-reveal" ref={addToSectionRefs}>
          <Portfolio />
        </div>
        <div className="section-reveal" ref={addToSectionRefs}>
          <Services />
        </div>
        <div className="section-reveal" ref={addToSectionRefs}>
          <Contact />
        </div>
      </main>
      <Footer />
      <BackgroundAnimation />
    </React.Fragment>
  );
};

export default App;